import styled from 'styled-components';

export const TitleBlock = styled.div`
  flex: 1;
  min-width: 0;
`;
